import React from "react";
import { Box, Typography } from "@mui/material";

export function getVisibleMediaForViewer({
  media = [],
  user,
  planner = false,
  galleryHiddenByHost = false,
  forceStrict = false,
}) {
  const uid = user?.uid || null;

  if (planner) return media;

  if (forceStrict || galleryHiddenByHost) {
    return uid
      ? media.filter((m) => m.userId === uid || m.uploaderUid === uid)
      : [];
  }

  return media;
}

export default function HiddenGalleryNotice({ planner, galleryHiddenByHost }) {
  if (!galleryHiddenByHost) return null;

  const message = planner
    ? {
        title: "Gallery Hidden",
        body:
          "Guests can still upload photos and customize their own uploads with Templates. Only you can view the full gallery until it's revealed.",
      }
    : {
        title: "Gallery Hidden",
        body:
          "You can still upload photos and customize your own uploads with Templates while you wait. Other guest photos stay hidden until the host reveals the gallery.",
      };

  return (
    <Box
      sx={{
        mx: 2,
        mt: 2,
        mb: 2,
        p: 2,
        borderRadius: 3,
        bgcolor: "rgba(255,255,255,0.9)",
        border: "1px solid rgba(0,0,0,0.08)",
        textAlign: "center",
      }}
    >
      <Typography sx={{ fontWeight: 900, mb: 0.5 }}>
        {message.title}
      </Typography>

      <Typography sx={{ fontSize: 14, color: "#555" }}>
        {message.body}
      </Typography>
    </Box>
  );
}